import React from "react";
import AuthenticityTokenField from "../../../components/forms/AuthenticityTokenField";
import { Button } from "../../../components/ui/Buttons";
import { FieldLabel, TextInput } from "../../../components/ui/FormControls";
import { SurfaceCard } from "../../../components/ui/SurfaceCard";
import { AppLink } from "../../../components/ui/link";
import { AuthPageLayout } from "./AuthPageLayout";
import type { MainAppPageProps } from "../types";

type VerifyEmailPageProps = Pick<
  MainAppPageProps,
  "csrfToken" | "routes" | "userForm"
>;

export const VerifyEmailPage: React.FC<VerifyEmailPageProps> = ({
  csrfToken,
  routes,
  userForm,
}) => (
  <AuthPageLayout>
    <h1 className="mb-3 text-center font-display text-3xl font-semibold tracking-tight text-foreground">
      Verify your email
    </h1>
    <p className="mb-8 text-center text-sm text-muted-foreground">
      {userForm?.email
        ? `Enter the code we sent to ${userForm.email}.`
        : "Enter the verification code from your email."}
    </p>
    <SurfaceCard className="rounded-2xl border-border p-8 shadow-lg">
      <form action={routes.verifyEmail} method="post">
        <AuthenticityTokenField csrfToken={csrfToken} />
        <div className="mb-6">
          <FieldLabel htmlFor="code">Verification code</FieldLabel>
          <TextInput
            id="code"
            name="code"
            type="text"
            inputMode="numeric"
            autoComplete="one-time-code"
            placeholder="123456"
            required
          />
        </div>
        <Button
          type="submit"
          variant="premium"
          className="w-full py-3 font-medium"
        >
          Verify email
        </Button>
      </form>
    </SurfaceCard>
    <p className="mt-6 text-center text-sm text-muted-foreground">
      <AppLink to={routes.login} variant="premium">
        Back to log in
      </AppLink>
    </p>
  </AuthPageLayout>
);
